import * as React from "react";
import { NavLink } from "react-router-dom";

import { Search } from "@common/_constants";
import { MessageService } from "@common/_services";
import { IconEnvelope } from "@common/components/Atoms/Icons";

interface MessageIndicatorProps {
    triggerMessageIndicator: boolean;
}

interface MessageIndicatorState {
    unreadCount: 0;
}

export class MessageIndicator extends React.Component<
    MessageIndicatorProps,
    MessageIndicatorState
    > {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props: MessageIndicatorProps) {
        super(props);
        this.state = {
            unreadCount: 0,
        };

        this.tick = this.tick.bind(this);
        this.getCount = this.getCount.bind(this);
    }

    private interval: any;

    componentWillReceiveProps(nextProps) {
        if (this.props.triggerMessageIndicator !== nextProps.triggerMessageIndicator) {
            this.getCount();
        }
    }

    componentDidMount() {
        this.getCount();

        this.interval = setInterval(() => this.tick(), 30 * 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key => abortControllers[key].abort());
        }
    }

    tick() {
        this.getCount();
    }

    getCount() {
        // Check to see if there already was an abortController, and if so, call abort on it
        if (this._abortControllers.unreadCount) {
            this._abortControllers.unreadCount.abort();
        }
        this._abortControllers.unreadCount = new AbortController();
        const signal = this._abortControllers.unreadCount.signal;

        return MessageService.unreadCount(signal)
            .then(result => this.setState({ unreadCount: result }))
            .catch(ex => console.log(ex));
    }

    render() {
        const { unreadCount } = this.state;
        return (
            <div className="c-message-indicator">
                <NavLink
                    to={`/messages?filter_type=${Search.MessageFilter.MY_UNREAD_MESSAGES}`}
                    className="c-message-indicator__icon no-underline no-hover"
                    activeClassName="is-active">
                    <IconEnvelope />
                </NavLink>
                {unreadCount !== 0 && (
                    <div className="c-message-indicator__count">
                        {unreadCount < 100 ? unreadCount : "!"}
                    </div>
                )}
            </div>
        );
    }
}

export default MessageIndicator;
